<script lang="ts" setup>
import { get } from '@vueuse/core'
import { Array, Order, pipe } from 'effect'
import type { HighScore } from '~/server/api/scores/all.get'

const { data } = useFetch<ReadonlyArray<HighScore>>('/api/scores/all')

const OrderHighScore = Order.mapInput(
  Order.reverse(Order.number),
  (h: HighScore) => h[1],
)

const HighScores = computed(() => pipe(
  get(data),
  e => e ?? [],
  Array.sort(OrderHighScore),
))
</script>

<template>
  <UCard>
    <template #header>
      <CardHeader>Ranglisten</CardHeader>
    </template>

    <div
      v-for="d, key in HighScores"
      :key
      class="text-xl pb-2"
    >
      <span class="text-primary-300">{{ key+1 }}) </span>
      <span class="font-bold">{{ d[0] }}: </span>
      <span class="text-zinc-400">{{ d[1] }}</span>
    </div>
  </UCard>
</template>
